import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./Popup.css";
import { CgCheckO } from "react-icons/cg";
import Prices from "../Prices";

const Popup = ({ show, handleClose }) => {
  const [plans, setPlans] = useState([
    { id: 1, duration: 6, original: 13200, acutal: 8640 },
    { id: 2, duration: 3, original: 6600, acutal: 4920 },
    { id: 3, duration: 1, original: 2200, acutal: 1960 },
    { id: 4, duration: 1, acutal: 95 },
  ]);

  const [isActive, setIsActive] = useState(1);
  const newWindow = () => {
    const planId=planLink()
    return window.open(`${planId}`,"_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=350,width=900,height=600")
    
  }
  const planLink = () =>{
      if (isActive===1){
          return  'https://rzp.io/l/yoganta-live-6-months-plan'
      }
      else if (isActive===2){
          return  'https://rzp.io/l/yoganta-live-3-months-plan'
      }
      else if (isActive===3){
        return  ' https://rzp.io/l/yoganta-live-monthly-plan'
      }
      else{
        return  'https://rzp.io/l/yoganta-live-demo'
      }
  }
  const handelClick = (id) => {
    setIsActive(id);
  };

  return (
    <Modal
      backdrop={"static"}
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="pricing-close-btn">
          <span
            style={{ color: "black" }}
            onClick={() => {
              handleClose();
            }}
          >
            &times;
          </span>
        </div>

        <div className="Pricing">
          <div className="main-section">
            <div className="content-main">
              <h4>YOGANTA LIVE</h4>
              <h5>Benefits</h5>
              <div className="content">
                <div className="content-sub">
                  <h6>
                    <CgCheckO />&nbsp;
                    Unlimited Yoga Classes
                  </h6>
                  <h6>
                    <CgCheckO />&nbsp;
                    Pause Membership
                  </h6>
                </div>
                <div className="content-sub">
                  <h6>
                    <CgCheckO />&nbsp;
                    Flexible Schedules
                  </h6>
                  <h6>
                    <CgCheckO />&nbsp;
                    Free Diet Consultation
                  </h6>
                </div>
              </div>
            </div>
            <div className="payment-main">
              <h3>Choose subscription plan</h3>
              {plans.map((plan) => {
                if (isActive === plan.id) {
                  return (
                    <div key={plan.id}>
                      <Prices
                        id={plan.id}
                        isActive={true}
                        duration={plan.duration}
                        original={plan.original}
                        acutal={plan.acutal}
                        handelClick={handelClick}
                      />
                      <hr />
                    </div>
                  );
                } else {
                  return (
                    <div key={plan.id}>
                      <Prices
                        id={plan.id}
                        isActive={false}
                        duration={plan.duration}
                        original={plan.original}
                        acutal={plan.acutal}
                        handelClick={handelClick}
                      />
                      <hr />
                    </div>
                  );
                }
              })}
            
              <button className="booknow" onClick={() => newWindow()}> 
                  PAY &nbsp;₹
                    {plans.map((plan) => {
                    if (plan.id === isActive) return plan.acutal;
                    })}
            </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Popup;
